import Head from 'next/head';
import type {FC} from 'react';
import {cn} from '../../../../../lib/classname';
import {
  type Breadcrumb,
  BreadcrumbsComponent,
} from '../../../../../shared/components/BreadcrumbsComponent';
import {createBreadCrumbsStructuredData} from '../../../../../shared/services/createBreadCrumbsStructuredData';
import {createJsonLdHtml} from '../../../../../shared/services/createJsonLdHtml';

type Props = {
  className?: string;
  breadcrumbs: Breadcrumb[];
};
export const Breadcrumbs: FC<Props> = ({className, breadcrumbs}) => {
  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={createJsonLdHtml(
            createBreadCrumbsStructuredData(breadcrumbs),
          )}
        />
      </Head>
      <div className={cn(className)}>
        <BreadcrumbsComponent crumbs={breadcrumbs} />
      </div>
    </>
  );
};
